<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.type" @change="handleTabs">
          <el-radio-button :label="2"
            ><el-badge is-dot class="item" :hidden="!isb"
              >保证金</el-badge
            ></el-radio-button
          >
          <el-radio-button :label="1">人才币</el-radio-button>
          <el-radio-button :label="3"
            ><el-badge is-dot class="item" :hidden="!isb1"
              >诚信保</el-badge
            ></el-radio-button
          >
          <el-radio-button :label="4">会员费</el-radio-button>
          <el-radio-button :label="5">兼职保证金</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-bottom: 10px">
        <el-radio-group
          size="medium"
          v-model="table.params.refund_status"
          @change="handleTabs2"
        >
          <el-radio-button :label="0">全部订单</el-radio-button>
          <el-radio-button
            v-show="[2, 3].includes(table.params.type)"
            :label="2"
            >退款中({{ refund_count }})</el-radio-button
          >
          <el-radio-button
            v-show="[5].includes(table.params.type)"
            :label="1"
            >未退款</el-radio-button
          >
          <el-radio-button
            v-show="[2, 3, 5].includes(table.params.type)"
            :label="3"
            >已处理</el-radio-button
          >
        </el-radio-group>
      </div>
      <div>
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          size="small"
          class="flex"
        >
          <el-form-item
            label="企业名称"
            prop="company_id"
            v-if="table.params.type == 1 || table.params.type == 2"
          >
            <el-select
              v-model="table.params.company_id"
              filterable
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="账号"
            prop="account_id"
            v-if="table.params.type == 3 || table.params.type == 4 || table.params.type == 5"
          >
            <el-select
              v-model="table.params.account_id"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              @change="handleSearch"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.account"
                :value="item.id"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px"
                  >({{ item.account }})</span
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付渠道" prop="pay_type">
            <el-select
              v-model="table.params.pay_type"
              placeholder="请选择"
              clearable
              @change="handleSearch"
            >
              <el-option label="微信" :value="1"></el-option>
              <el-option label="支付宝" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易流水号" prop="order_no">
            <el-input
              clearable
              v-model="table.params.order_no"
              placeholder="请输入交易流水号"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="table.params.type == 5 ? '支付时间': table.params.refund_status == 3 ? '处理时间' : '支付时间'"
            prop="pay_time"
          >
            <el-date-picker
              style="width: 250px"
              v-model="table.params.pay_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="状态"
            prop="refund_amount_status"
            v-show="table.params.refund_status == 0"
            v-if="table.params.type == 2 || table.params.type == 3 || table.params.type == 5"
          >
            <el-select
              v-model="table.params.refund_amount_status"
              filterable
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option label="未退款" :value="1"> </el-option>
              <el-option label="部分退款" :value="2"> </el-option>
              <el-option label="全部退款" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <template v-if="table.params.refund_status == 0">
        <VTable
          has-pagionation
          indexLabel="序号"
          title=""
          :field="
            getFieldRefund0()
          "
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:company_name="{ row }">
            {{
              [2, 1].includes(table.params.type)
                ? row.company_name
                : row.nickname
            }}
          </template>
          <template v-slot:is_refund="{ row }">
            {{
              toStr(
                { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
                row.is_refund
              )
            }}
          </template>
          <template v-slot:refund_amount_status="{ row }">
            {{
              toStr(
                { 1: "未退款", 2: "部分退款", 3: "全部退款" },
                row.refund_amount_status
              )
            }}
          </template>
          <template
            v-slot:action="{ row }"
            v-if="[2, 3].includes(table.params.refund_status)"
          >
            <el-button
              v-if="table.params.refund_status == 2"
              type="text"
              @click="handleRefund(row)"
              >处理</el-button
            >
            <el-button
              v-if="table.params.refund_status == 3"
              type="text"
              @click="viewRefund(row)"
              >查看</el-button
            >
          </template>
        </VTable>
      </template>
      <template v-if="table.params.refund_status == 2">
        <VTable
          has-pagionation
          indexLabel="序号"
          title=""
          :field="getFieldRefund2()"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:kou="{ row }">
            {{ row.amount - row.refund_amount }}
          </template>
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:company_name="{ row }">
            {{
              [2, 1].includes(table.params.type)
                ? row.company_name
                : row.nickname
            }}
          </template>
          <template v-slot:is_refund="{ row }">
            {{
              toStr(
                { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
                row.is_refund
              )
            }}
          </template>
          <template v-slot:refund_amount_status="{ row }">
            {{
              toStr(
                { 1: "未退款", 2: "部分退款", 3: "全部退款" },
                row.refund_amount_status
              )
            }}
          </template>
          <template v-slot:work_status="{ row }">
            {{ toStr({ 1: "入职满10天", 2: "已离职" }, row.work_status) }}
          </template>
          <template
            v-slot:action="{ row }"
            v-if="[2, 3].includes(table.params.refund_status)"
          >
            <el-button
              v-if="table.params.refund_status == 2"
              type="text"
              @click="handleRefund(row)"
              >处理</el-button
            >
            <el-button
              v-if="table.params.refund_status == 3"
              type="text"
              @click="viewRefund(row)"
              >查看</el-button
            >
          </template>
        </VTable>
      </template>
      <template v-if="table.params.refund_status == 3">
        <VTable
          has-pagionation
          indexLabel="序号"
          title=""
          :field="getFieldRefund3()"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:kou="{ row }">
            {{ row.amount - row.refund_amount }}
          </template>
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:company_name="{ row }">
            {{
              [2, 1].includes(table.params.type)
                ? row.company_name
                : row.nickname
            }}
          </template>
          <template v-slot:is_refund="{ row }">
            <!-- <span v-if="table.params.type == 5 && table.params.refund_status == 3 && !row.check_time">
              已罚没
            </span>
            <span v-else>
              {{
              toStr(
                { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
                row.is_refund
                )
              }}
            </span> -->
            <span v-if="row.is_refund == 2">已退款</span>
            <span v-else>已罚没</span>
          </template>
          <template v-slot:refund_amount_status="{ row }">
            {{
              toStr(
                { 1: "未退款", 2: "部分退款", 3: "全部退款" },
                row.refund_amount_status
              )
            }}
          </template>
          <template v-slot:work_status="{ row }">
            {{ toStr({ 1: "入职满10天", 2: "已离职" }, row.work_status) }}
          </template>
          <template
            v-slot:action="{ row }"
            v-if="[2, 3].includes(table.params.refund_status)"
          >
            <el-button
              v-if="table.params.refund_status == 2"
              type="text"
              @click="handleRefund(row)"
              >处理</el-button
            >
            <el-button
              v-if="table.params.refund_status == 3"
              type="text"
              @click="viewRefund(row)"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="
                table.params.type == 3 &&
                table.params.refund_status == 3 &&
                row.can_deduct == 1
              "
              @click="viewReturn(row)"
              >扣取服务费</el-button
            >
          </template>
        </VTable>
      </template>
      <template v-if="table.params.refund_status == 1">
        <VTable
          has-pagionation
          indexLabel="序号"
          title=""
          :field="getFieldRefund1()"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:kou="{ row }">
            {{ row.amount - row.refund_amount }}
          </template>
          <template v-slot:pay_type="{ row }">
            {{ row.pay_type == 1 ? "微信" : "支付宝" }}
          </template>
          <template v-slot:company_name="{ row }">
            {{
              [2, 1].includes(table.params.type)
                ? row.company_name
                : row.nickname
            }}
          </template>
          <template v-slot:is_refund="{ row }">
            {{
              toStr(
                { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
                row.is_refund
              )
            }}
          </template>
          <template v-slot:refund_amount_status="{ row }">
            {{
              toStr(
                { 1: "未退款", 2: "部分退款", 3: "全部退款" },
                row.refund_amount_status
              )
            }}
          </template>
          <template v-slot:work_status="{ row }">
            {{ toStr({ 1: "入职满10天", 2: "已离职" }, row.work_status) }}
          </template>
          <template
            v-slot:action="{ row }"
            v-if="[2, 3].includes(table.params.refund_status)"
          >
            <el-button
              v-if="table.params.refund_status == 2"
              type="text"
              @click="handleRefund(row)"
              >处理</el-button
            >
            <el-button
              v-if="table.params.refund_status == 3"
              type="text"
              @click="viewRefund(row)"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="
                table.params.type == 3 &&
                table.params.refund_status == 3 &&
                row.can_deduct == 1
              "
              @click="viewReturn(row)"
              >扣取服务费</el-button
            >
          </template>
        </VTable>
      </template>
    </div>
    <handleRefundDialog
      @update="getTable"
      ref="handleRefundDialog"
    ></handleRefundDialog>
    <refundDetailDialog ref="refundDetailDialog"></refundDetailDialog>
    <returnDialog ref="returnDialog" @update="getTable"></returnDialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import handleRefundDialog from "./components/handleRefundDialog.vue";
import refundDetailDialog from "./components/refundDetailDialog.vue";
import returnDialog from "./components/returnDialog.vue";
export default {
  name: "CompanyList",
  mixins: [mixinTable],
  components: {
    VTable,
    handleRefundDialog,
    refundDetailDialog,
    returnDialog,
  },
  data() {
    return {
      field0: [
        { name: "company_name", label: "名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "amount", label: "支付金额/元", hidden: false },
        { name: "pay_type", label: "支付渠道", hidden: false },
        { name: "order_no", label: "交易流水号", hidden: false },
        { name: "pay_time", label: "支付时间", hidden: false },
      ],
      field1: [
        { name: "company_name", label: "名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "amount", label: "支付金额/元", hidden: false },
        { name: "pay_type", label: "支付渠道", hidden: false },
        { name: "order_no", label: "交易流水号", hidden: false },
        { name: "pay_time", label: "支付时间", hidden: false },
        { name: "refund_amount_status", label: "状态", hidden: false },
      ],
      field2: [
        { name: "company_name", label: "名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "amount", label: "总支付金额/元", hidden: false },
        { name: "kou", label: "扣款金额", hidden: false },
        { name: "current_earnest", label: "当前余额", hidden: false },
        { name: "refund_amount", label: "退款金额", hidden: false },
        { name: "refund_reason", label: "退款原因", hidden: false },
        { name: "apply_time", label: "申请时间", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      field3: [
        { name: "company_name", label: "名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "amount", label: "总支付金额/元", hidden: false },
        { name: "kou", label: "扣款金额", hidden: false },
        { name: "current_earnest", label: "当前余额", hidden: false },
        { name: "refund_amount", label: "退款金额", hidden: false },
        { name: "refund_reason", label: "退款原因", hidden: false },
        { name: "check_time", label: "处理时间", hidden: false },
        { name: "is_refund", label: "处理结果", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      field4: [
        { name: "company_name", label: "名称", hidden: false },
        { name: "account", label: "账号", hidden: false },
        { name: "amount", label: "总支付金额/元", hidden: false },
        { name: "kou", label: "扣款金额", hidden: false },
        { name: "refund_amount", label: "退款金额", hidden: false },
        { name: "work_status", label: "退款原因", hidden: false },
        // { name: "check_time", label: "处理时间", hidden: false },
        { name: "is_refund", label: "处理结果", hidden: false },
        { name: "apply_time", label: "申请时间", hidden: false },
        { name: "action", label: "操作", hidden: false },
      ],
      field5: [
        { name: "nickname", label: "名称", hidden: false,width:150 },
        { name: "account", label: "账号", hidden: false,width:150 },
        { name: "job_name", label: "报名岗位", hidden: false,width:150 },
        { name: "company_name5", label: "所属企业", hidden: false,},
        { name: "amount", label: "支付金额/元", hidden: false },
        { name: "order_no", label: "支付流水号", hidden: false,width:180 },
        { name: "pay_time", label: "支付时间", hidden: false ,width:180},
        { name: "is_refund", label: "状态", hidden: false },
        { name: "check_time", label: "处理时间", hidden: false, },
      ],
      field6: [
        { name: "nickname", label: "名称", hidden: false,width:150 },
        { name: "account", label: "账号", hidden: false,width:150 },
        { name: "job_name", label: "报名岗位", hidden: false,width:150 },
        { name: "company_name5", label: "所属企业", hidden: false, },
        { name: "amount", label: "支付金额/元", hidden: false ,width:180},
        { name: "order_no", label: "支付流水号", hidden: false,width:180 },
        { name: "pay_time", label: "支付时间", hidden: false ,},
      ],
      refund_count: "",
      table: {
        loading: false,
        params: {
          type: 2,
          refund_status: 0,
          account_id: "",
          pay_type: "",
          order_no: "",
          company_id: "",
          pay_time: [],
          page: 1,
          count: 10,
          refund_amount_status: "",
        },
        data: [],
        total: 0,
      },
      companyList: [],
      options: [],
      isb: false,
      isb1: false,
    };
  },
  created() {
    this.$http
      .post("/admin/notice/new", {})
      .then((res) => {
        if (res.code === 1) {
          this.isb = res.data.earnest_unread != 0;
          this.isb1 = res.data.vip_unread != 0;
        }
      })
      .then(() => {
        this.getTable();
      });
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      this.$http
        .get("admin/company/list", {
          params: { page: 1, count: 10000, type: 2 },
        })
        .then((res) => {
          if (res.code === 1) {
            this.companyList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getTable() {
      this.table.data = [];
      let params_ = {
        ...this.table.params,
        pay_time: this.table.params.pay_time
          ? this.table.params.pay_time.join("|")
          : "",
        refund_amount_status:
          (this.table.params.type == 2 || this.table.params.type == 3) &&
          this.table.params.refund_status == 0
            ? this.table.params.refund_amount_status
            : "",
        type: this.table.params.type == 4 ? 3 : this.table.params.type,
      };
      if(params_.type == 5) {
        params_.type = 4; //实际为4，此处仅为兼容旧代码
      }
      this.$http.get("/admin/order/list", { params: params_ }).then((res) => {
        if (res.code === 1) {
          this.table.data = res.data.list;
          if(params_.type = 4) {
            this.table.data = this.table.data.map(i =>{
              return {
                ...i,
                company_name5:i.company_name
              }
            })
          }
          this.table.total = res.data.total;
          this.refund_count = res.data.refund_count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    reset() {
      // this.$refs.elFormDom.resetFields();
      this.table.params = {
        type: this.table.params.type,
        refund_status: 0,
        account_id: "",
        pay_type: "",
        order_no: "",
        company_id: "",
        pay_time: [],
        page: 1,
        count: 10,
        refund_amount_status: "",
      };
      this.getTable();
    },
    // 切换状态
    handleTabs(value) {
      this.table.params.page = 1;
      // this.$refs.elFormDom.resetFields();
      this.table.params = {
        type: value,
        refund_status: 0,
        account_id: "",
        pay_type: "",
        order_no: "",
        company_id: "",
        pay_time: [],
        page: 1,
        count: 10,
        refund_amount_status: "",
      };
      if (value == 4) {
        this.table.params.vip_type = 2;
      } else {
        delete this.table.params.vip_type;
      }
      // this.table.params.refund_status = 0;
      // this.table.params.account_id = "";
      this.table.data = [];
      this.getTable();
    },
    handleTabs2() {
      this.table.data = [];
      this.getTable();
    },
    refresh(status) {
      this.table.params.status === status;
      this.getTable();
    },
    handleRefund(row) {
      let dom = this.$refs.handleRefundDialog;
      dom.toggle(true);
      dom.getDetail({
        ...row,
        type: this.table.params.type,
      });
      dom = null;
    },
    viewReturn(row) {
      let dom = this.$refs.returnDialog;
      dom.toggle(true);
      dom.getDetail({
        ...row,
        type: this.table.params.type,
      });
      dom = null;
    },
    viewRefund(row) {
      let dom = this.$refs.refundDetailDialog;
      dom.toggle(true);
      dom.getDetail({
        ...row,
        type: this.table.params.type,
      });
      dom = null;
    },
    remoteMethod(query) {
      this.options = [];
      if (query !== "") {
        let params = {
          keyword: query,
          page: 1,
          type: 1,
          count: 10000,
        };
        this.$http.get("/admin/user/list", { params: params }).then((res) => {
          if (res.code === 1) {
            this.options = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.options = [];
      }
    },
    getFieldRefund0() {
      if(this.table.params.type == 5){
        return this.field6
      }
      if(this.table.params.type == 1 || this.table.params.type == 4){
        return this.field0
      }else {
        return this.field1
      }
    },
    getFieldRefund1() {
      if(this.table.params.type == 5){
        return this.field6
      }
    },
    getFieldRefund2() {
      if(this.table.params.type == 5){
        return this.field6
      }
      if(this.table.params.type == 2){
        return this.field2
      }else {
        return this.field4
      }
    },
    getFieldRefund3() {
      if(this.table.params.type == 5){
        return this.field5
      }
      if(this.table.params.type == 2){
        return this.field3
      }else {
        return this.field4
      }
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>